module.exports = __webpack_public_path__ + "static/media/LogoMatheus.a1648095.png";